import { render, staticRenderFns } from "./AutocompleteHeadTeacherCard.vue?vue&type=template&id=192a12fb"
import script from "./AutocompleteHeadTeacherCard.vue?vue&type=script&lang=js"
export * from "./AutocompleteHeadTeacherCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports